import type {
  OptionItemType,
  SegyHeaderCoordsType,
  SegySampleParamsInfo,
  SurveyType,
  UploadedFileStepType,
} from '@core/core/types'
import type { CommonDomainType } from 'common/types'

import {
  TRACE_CDP_ILINE_OFFSET,
  TRACE_CDP_X_OFFSET,
  TRACE_CDP_XLINE_OFFSET,
  TRACE_CDP_Y_OFFSET,
  TRACE_SOURCE_ILINE_OFFSET,
  TRACE_SOURCE_X_OFFSET,
  TRACE_SOURCE_XLINE_OFFSET,
  TRACE_SOURCE_Y_OFFSET,
} from './constants'
import type { ChoiceItemType, CoordinatesType, OptionHeaderType } from './types'

export enum CoordinateName {
  X = 'X',
  Y = 'Y',
  Inline = 'Inline',
  Crossline = 'Crossline',
}

export const stepsItems: Record<UploadedFileStepType, string> = {
  setup: 'Настройка',
  mapping: 'Маппинг',
  loading: 'Загрузка',
  conversion: 'Конвертация',
  ready: 'Готово',
}

export const formatItems = [
  { label: 'IBM плавающая точка' },
  { label: 'IEEE плавающая точка' },
  { label: '8-битный (нестандартный)' },
  { label: '16-битная фиксированная точка' },
  { label: '32-битная фиксированная точка' },
]

// TODO раскомментировать когда появится возможность выбора формата
// const selectItems = [
//   { label: '2 байт (16-битное) целое число' },
//   { label: '4 байта (32-битное) целое число' },
//   { label: '4 байта IEEE плавающая точка' },
//   { label: '4 байта IBM плавающая точка' },
// ]
export const typeChoiceItems: ChoiceItemType<SurveyType>[] = [
  { name: 'Survey2D', label: '2D', disabled: true },
  { name: 'Survey3D', label: '3D', disabled: false },
]
export const domainChoiceItems: ChoiceItemType<CommonDomainType>[] = [
  { name: 'TWT', label: 'TWT', disabled: false },
  { name: 'Z', label: 'Z', disabled: false },
]

const maxNumber = 240
const values = Array.from({ length: maxNumber }, (_, i) => ({ label: (i + 1).toString() }))

export const coordinates: CoordinatesType[] = [
  { name: CoordinateName.X, values, coordName: 'x' },
  { name: CoordinateName.Y, values, isPadding: true, coordName: 'y' },
  { name: CoordinateName.Inline, values, coordName: 'iline' },
  { name: CoordinateName.Crossline, values, coordName: 'xline' },
]

export const requiredOptions: OptionItemType<keyof SegySampleParamsInfo>[] = [
  { label: 'Шаг дискретизации, мc', name: 'interval' },
  { label: 'Количество значений', name: 'samplesPerTrace' },
  { label: 'Начало записи, мс', name: 'startRecord' },
  { label: 'Масштаб координат', name: 'scale' },
]
export const headerChoiceItems = [
  { name: 'Текстовый заголовок' },
  { name: 'Бинарный заголовок' },
  { name: 'Трассы' },
]

export const coordTemplateTypes: SegyHeaderCoordsType[] = [
  {
    x: { offset: TRACE_SOURCE_X_OFFSET + 1, type: undefined },
    y: { offset: TRACE_SOURCE_Y_OFFSET + 1, type: undefined },
    iline: { offset: TRACE_SOURCE_ILINE_OFFSET + 1, type: undefined },
    xline: { offset: TRACE_SOURCE_XLINE_OFFSET + 1, type: undefined },
  },
  {
    x: { offset: TRACE_CDP_X_OFFSET + 1, type: undefined },
    y: { offset: TRACE_CDP_Y_OFFSET + 1, type: undefined },
    iline: { offset: TRACE_CDP_ILINE_OFFSET + 1, type: undefined },
    xline: { offset: TRACE_CDP_XLINE_OFFSET + 1, type: undefined },
  },
]

export const optionHeaderTypes: OptionHeaderType[] = [
  { name: 'INT_2_BYTES', label: '2 байт (16-битное) целое число' },
  { name: 'INT_4_BYTES', label: '4 байта (32-битное) целое число' },
  { name: 'IEEE_FLOATING_POINT', label: '4 байта IEEE плавающая точка' },
  { name: 'IBM_FLOATING_POINT', label: '4 байта IBM плавающая точка' },
]
